<template>
	<div class="class-items">
		<template  v-for="item in itemsData">
			<div style="margin-top:25px; margin-bottom:25px;" v-if="item.REPORT_TYPE === 'H'" :key="item.LINE_NO" v-html="item.REPORT_DESCRIPTION"></div>
			<div class="flex-container box" :key="item.LINE_NO" v-else>
				<!-- icon -->
				<div class="category-icon" :class="getColorClass( item.REPORT_TYPE )">
					<div class="icon">
						<font-awesome-icon :icon="'REPORT-TYPE-O-open' | iconClass" v-if="item.REPORT_TYPE === 'O' && isFolderOpen( item.LINE_NO )"></font-awesome-icon>
						<font-awesome-icon :icon="'REPORT-TYPE-' + item.REPORT_TYPE | iconClass" v-else></font-awesome-icon>
					</div>
				</div>

				<!-- Folder class item -->
				<div class="content-details" v-if="item.REPORT_TYPE === 'O'">
					<a href="javascript:void(0)" @click="toggleFolder( item.LINE_NO )"><h3>{{ item.REPORT_NAME }} <span class="badge badge-secondary">{{item.FILES.length}}</span></h3></a>
					<p style="white-space: pre-wrap;" v-html="item.REPORT_DESCRIPTION"></p>
					<div class="folder-items" v-if="isFolderOpen( item.LINE_NO )">
						<p v-if="!item.FILES.length">
							<i>{{ $t( 'MAIN_CONTENT.classPage.ClassItems.noFilesMessage' ) }}</i>
						</p>
						<div v-for="file in item.FILES" :key="file.REPORT_ID">
							<font-awesome-icon
								:icon="file.CONTENT_TYPE | iconClass" aria-hidden="true"
							/> 
							<a
								:href="file.REPORT_URL"
								target="_blank"
							>
								{{ file.CONTENT_FILENAME }}
								<aria-new-tab-message
									:message="$t( 'MAIN_CONTENT.Accessibility.opensInNewTab' )"
								/>
							</a> 
						</div>
					</div>
				</div>
				<!-- Link class item -->
				<div class="content-details" v-else-if="item.REPORT_TYPE === 'L'">
					<a :href="item.LINK_LOCATION" target="_blank"><h3>{{ item.REPORT_NAME }}</h3><aria-new-tab-message :message="$t( 'MAIN_CONTENT.Accessibility.opensInNewTab' )" /></a>
					<p style="white-space: pre-wrap;" v-html="item.REPORT_DESCRIPTION"></p>
				</div>
				<!-- Announcement class item -->
				<div class="content-details" v-else-if="item.REPORT_TYPE === 'A'">
					<h3>{{ item.REPORT_NAME }}</h3>
					<p style="white-space: pre-wrap;" v-html="item.REPORT_DESCRIPTION"></p>
				</div>
				<!-- Lesson Plan class item -->
				<div class="content-details" v-else-if="item.REPORT_TYPE === 'E'">
					<a @click="logClassPageActivity(item)" :href="item.REPORT_URL" target="_blank"><h3>{{ item.REPORT_NAME }}</h3><aria-new-tab-message :message="$t( 'MAIN_CONTENT.Accessibility.opensInNewTab' )" /></a>
					<p style="white-space: pre-wrap;" v-html="item.REPORT_DESCRIPTION"></p>
				</div>
				<!-- File class item -->
				<div class="content-details" v-else-if="item.REPORT_TYPE === 'F'">
					<a @click="logClassPageActivity(item)" :href="item.REPORT_URL" target="_blank"><h3>{{ item.REPORT_NAME }}</h3><aria-new-tab-message :message="$t( 'MAIN_CONTENT.Accessibility.opensInNewTab' )" /></a>
					<p style="white-space: pre-wrap;" v-html="item.REPORT_DESCRIPTION"></p>
				</div>
				<!-- Page class item -->
				<div class="content-details" v-else-if="item.REPORT_TYPE === 'P'">
					<a @click.prevent="goToSubpage(item)" href="#"><h3>{{ item.REPORT_NAME }}</h3></a>
				</div>
				<!-- Forum class item -->
				<div class="content-details" v-else-if="item.REPORT_TYPE === 'T'">
					<a @click.prevent="goToForum(item)" href="#">
						<h3>
							{{ item.REPORT_NAME }} <span v-if="item.NEW_ITEMS_FLG == 'Y'" class="badge badge-pill bg-teal">{{$t("MAIN_CONTENT.commonContent.newPosts")}}</span>
						</h3>
					</a>
					<p v-html="item.REPORT_DESCRIPTION"></p>
				</div>
				<!-- External Tool class item -->
				<div class="content-details" v-else-if="item.REPORT_TYPE === 'I'">
					<a @click.prevent="goToLTILaunch(item)" href="#" target="_blank"><h3>{{ item.REPORT_NAME }}</h3><aria-new-tab-message :message="$t( 'MAIN_CONTENT.Accessibility.opensInNewTab' )" /></a>
					<p style="white-space: pre-wrap;" v-html="item.REPORT_DESCRIPTION"></p>
				</div>
				<!-- Glossary class item -->
				<div class="content-details" v-else-if="item.REPORT_TYPE === 'G'">
					<a @click.prevent="goToGlossary(item)" href="#"><h3>{{ item.REPORT_NAME }}</h3></a>
					<p style="white-space: pre-wrap;" v-html="item.REPORT_DESCRIPTION"></p>
				</div>
				<!-- Assignment Bin class item -->
				<div class="content-details" v-else-if="item.REPORT_TYPE === 'D'">
					<a @click.prevent="goToAssignmentBin(item)" href="#"><h3>{{ item.REPORT_NAME }}</h3></a>
					<p style="white-space: pre-wrap;" v-html="item.REPORT_DESCRIPTION"></p>
				</div>
				<div class="content-details" v-else>
					<a @click="logClassPageActivity(item)" href="" target="_blank"><h3>{{ item.REPORT_NAME }}</h3></a>
					<p style="white-space: pre-wrap;" v-html="item.REPORT_DESCRIPTION"></p>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import LogClassPageActivityResource from '../../api/ClassPageLog';
import { mapGetters } from 'vuex';

export default {
	props: {
		itemsData : {
				type: Array
		},
		folderType: {
			type: String,
			required: true,
		},
		groupId: String | Number,
	},
	data() {
		return {
			openFolders : []
		}
	},
	computed: {
		...mapGetters(['selectedStudent', 'roleRules']),
	},
	methods : {
		getColorClass( code ) {
			return 'container-' + this.$options.filters.mappedColor( "REPORT-TYPE-" + code );
		},
		toggleFolder( id ) {
			let idx = this.openFolders.findIndex( folder => folder === id );
			if( idx < 0 ){
				this.openFolders.push( id );
			} else {
				this.openFolders.splice( idx, 1 );
			}
		},
		isFolderOpen( id ){
			return this.openFolders.findIndex( folder => folder === id ) > -1; 
		},
		goToSubpage(item){
			this.logClassPageActivity(item);
			
			const viewsMap = {
				"C": "ClassPageSubpage",
				"G": "ClassPageGroupSubpage",
				"S": "ClassPageStudentSubpage",
				"P": "ClassPageSectionSubpage"
			};
			const view = viewsMap[this.folderType];

			this.$router.push({
				name: view, 
				params: {
					courseSectionGUID: this.$route.params.courseSectionGUID,
					studentRid: this.selectedStudent.STUDENT_RID,
					lineNo: item.LINE_NO
				}
			});
		},
		goToGlossary(item) {
			this.logClassPageActivity(item);

			this.$router.push({
				name: 'CoursesGradesGlossary',
				params: {
					courseSectionGUID: this.$route.params.courseSectionGUID,
					glossaryType: this.folderType,
					glossaryID: item.LINE_NO
				}
			});
		},
		goToForum(item){
			this.logClassPageActivity(item);

			const viewsMap = {
				"C": "ClassPageForum",
				"G": "ClassPageGroupForum",
				"S": "ClassPageStudentForum",
				"P": "ClassPageSectionForum"
			};
			const view = viewsMap[this.folderType];

			let params = {
				courseSectionGUID: this.$route.params.courseSectionGUID,
				studentRid: this.selectedStudent.STUDENT_RID,
				forumId: item.FORUM_ID
			};

			if( this.folderType === 'G' ){
				params.groupId = this.groupId;
			}

			if( this.folderType === 'S'){
				params.studentRid = this.selectedStudent.STUDENT_RID;
			}

			this.$router.push({
				name: view, 
				params: params,
			});
		},
		goToLTILaunch(item){
			this.logClassPageActivity(item);
			
			const viewsMap = {
				"C": "ClassPageLTILaunch",
				"G": "ClassPageGroupLTILaunch",
				"S": "ClassPageStudentLTILaunch",
				"P": "ClassPageLTILaunch"
			};
			const view = viewsMap[this.folderType];

			let params = {
				courseSectionGUID: this.$route.params.courseSectionGUID,
				studentRid: this.selectedStudent.STUDENT_RID,
				lineNo: item.LINE_NO
			};

			if( this.folderType === 'G' ){
				params.groupId = this.groupId;
			}

			let routeData = this.$router.resolve({
				name: view, 
				params: params,
			});

			window.open(routeData.href, '_blank');
		},
		goToAssignmentBin(item){
			this.logClassPageActivity(item);

			const viewsMap = {
				"C": "ClassPageAssignmentBin",
				"G": "ClassPageGroupAssignmentBin",
				"S": "ClassPageStudentAssignmentBin",
				"P": "ClassPageSectionAssignmentBin"
			};
			const view = viewsMap[this.folderType];

			let params = {
				courseSectionGUID: this.$route.params.courseSectionGUID,
				studentRid: this.selectedStudent.STUDENT_RID,
				assignmentBinId: item.LINE_NO
			};

			if( this.folderType === 'G' ){
				params.groupId = this.groupId;
			}

			if( this.folderType === 'S'){
				params.studentRid = this.selectedStudent.STUDENT_RID;
			}

			this.$router.push({
				name: view, 
				params: params,
			});
		},
		logClassPageActivity(item){

			let folderType = this.folderType;
			if( folderType === 'P' ){
				folderType = 'C';
			}

			const logClassPageActivity = new LogClassPageActivityResource({
				routeParams: {
					courseSectionGuid: this.$route.params.courseSectionGUID,
				},
				query: {
					student_rid: this.selectedStudent.STUDENT_RID,
				},
				data: {
					"folder_type": folderType,
					"line_no": item.LINE_NO
				},
			});

			logClassPageActivity.post();
		}
	}
}
</script>
